/**
 * Shared meta input. Single-line text by default; pass type="number" for
 * numerics. Reports focus changes for presence indicators.
 */

import type { BatchData } from '../types';

interface Props {
  label: string;
  id: keyof BatchData;
  placeholder?: string;
  type?: 'text' | 'number' | 'date';
  data: BatchData;
  onPatch: (p: Partial<BatchData>) => void;
  onFocusField: (id: string | null) => void;
  className?: string;
}

export default function MetaField({
  label,
  id,
  placeholder,
  type = 'text',
  data,
  onPatch,
  onFocusField,
  className,
}: Props) {
  const val = (data[id] ?? '') as string;
  return (
    <div className={'field' + (className ? ' ' + className : '')}>
      <label className="field-label">{label}</label>
      <input
        className="field-input"
        type={type}
        value={val}
        placeholder={placeholder}
        onChange={(e) => onPatch({ [id]: e.target.value } as Partial<BatchData>)}
        onFocus={() => onFocusField(String(id))}
        onBlur={() => onFocusField(null)}
      />
    </div>
  );
}

interface AreaProps {
  label: string;
  id: keyof BatchData;
  placeholder?: string;
  data: BatchData;
  onPatch: (p: Partial<BatchData>) => void;
  onFocusField: (id: string | null) => void;
  className?: string;
}

export function MetaTextarea({
  label,
  id,
  placeholder,
  data,
  onPatch,
  onFocusField,
  className,
}: AreaProps) {
  const val = (data[id] ?? '') as string;
  return (
    <div className={'field' + (className ? ' ' + className : '')}>
      <label className="field-label">{label}</label>
      <textarea
        className="field-textarea"
        value={val}
        placeholder={placeholder}
        onChange={(e) => onPatch({ [id]: e.target.value } as Partial<BatchData>)}
        onFocus={() => onFocusField(String(id))}
        onBlur={() => onFocusField(null)}
      />
    </div>
  );
}
